module.exports = __webpack_public_path__ + "dde195ca39aae813acc8f8dbaaa00352.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/loading-animation.gif
 ** module id = 540
 ** module chunks = 1
 **/